<template>
  <div id="view">
    <!-- <van-icon name="arrow-left" class="close" @click="$router.go(-1)"/> -->
    <van-loading v-show="isShowLoad" class="loading"/>
    <!-- <img src="../assets/iconImg/loading.gif"  v-if="isShowLoad" class="loading"> -->
    <!-- <img src="../assets/iconImg/yansy-loading.gif"  v-if="isShowLoad" class="loading-bg"> -->
    <span class="loading-text" v-if="isShowLoad">三维数据较大，建议在Wi-Fi环境浏览，请耐心等待~</span>
    <van-icon name="cross" @click="close" class="button" v-if="isShowButton"/>

    <i
      class="iconfont icon-bofang3 play"
      @click="handlerWalk"
      v-if="isShowWalk && !isShowVideo && !isShowButton && isPlayer "
    ></i>
    <i
      class="iconfont icon-zanting2 play"
      @click="handlerWalk"
      v-if="isShowWalk && !isShowVideo && !isShowButton && !isPlayer "
    ></i>

    <van-icon name="close" class="video-close" @click="closeVideo" v-if="isShowVideo"/>
    <video :src="videoSrc" autoplay loop playsinline id="video" v-if="isShowVideo"></video>

    <div class="details-wrapper" v-if="isShowDetail">
      <!-- <i class="iconfont iconfanhui1 close"  @click="closeDetail" ></i> -->
      <van-icon name="arrow-left" class="close" @click="closeDetail"/>
      <i class="iconfont icon-gouwuche2 cart" @click="buy"></i>

      <div class="left">
        <div class="img-wrapper">
          <img :src="modelDetail.preview360[0]" alt>
        </div>
        <!-- <div class="button-wrapper">
          <van-button type="default" class="buy" @click="buy">立即购买</van-button>
        </div>-->
      </div>
      <div class="right" id="right">
        <div class="name">{{modelDetail.name}}</div>
        <div id="content-wrapper">
          <div id="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let xScroll = {
  transitionTime: ".5",
  /**
   *
   * @param dom 执行侧滑的dom元素对象，额外添加属性 xScrollCoord = {"moveX": 0, "moveY": 0}; 记录当前滑动到的位置
   *              dom == jQuery对象时转为dom元素对象
   *              通过 dom.xInitParameters对象保存所有初始参数
   *              通过 dom.xScrollCoord 对象保存移动坐标参数
   * @param maxTranslate  滑动上限
   * @param minTranslate  滑动下限
   * @param isVertical  true上下滑动，false || undefined 左右滑动
   *            左右滑动例  ：  xScroll.scroll(dom,0,-300);
   *@param touchendCallBackFun call(this,e,orientation) -->> this触发事件dom元素对象，e触发事件对象，
   *          orientation滑动方向(如垂直（isVertical = true）则可通过该参数得到是下拉刷新还是上拉加载更多)
   *          isVertical ? orientation ？下拉至顶 ：上拉至底 : orientation ? 左滑到底 : 右滑到底
   *          orientation == undefined -->> 未滑至上限或者下限
   */
  scroll: function(
    dom,
    maxTranslate,
    minTranslate,
    isVertical,
    touchendCallBackFun
  ) {
    if (!maxTranslate) maxTranslate = 0;

    if (!minTranslate) throw "minTranslate : " + minTranslate;

    if ("function" == typeof isVertical) {
      touchendCallBackFun = isVertical;
      isVertical = false;
    }

    if (dom.jquery) {
      dom = dom[0];
    }

    dom.xInitParameters = {
      xstart: 0,
      xdifference: 0,
      xisMove: false,
      xmaxTranslate: maxTranslate,
      xminTranslate: minTranslate,
      xisVertical: isVertical,
      xtouchendCallBackFun: touchendCallBackFun
    };
    dom.xScrollCoord = { moveX: 0, moveY: 0 };

    dom.addEventListener("touchstart", function(e) {
      if (this.xInitParameters.xisVertical)
        this.xInitParameters.xstart = e.touches[0].clientX;
      else this.xInitParameters.xstart = e.touches[0].clientX;
    });

    dom.addEventListener("touchend", function(e) {
      if (!this.xInitParameters.xisMove) {
        return;
      }
      var orientation = undefined;

      if (this.xInitParameters.xisVertical) {
        if ( this.xScrollCoord.moveY + this.xInitParameters.xdifference > this.xInitParameters.xmaxTranslate) {
          this.xScrollCoord.moveY = this.xInitParameters.xmaxTranslate;
          orientation = true;
        // } else if ( this.xScrollCoord.moveY + this.xInitParameters.xdifference < this.xInitParameters.xminTranslate) {
        //   this.xScrollCoord.moveY = this.xInitParameters.xminTranslate;
        //   orientation = false;
        } else {
          this.xScrollCoord.moveY += this.xInitParameters.xdifference;
        }
        xScroll.xTrans.translateY(this, this.xScrollCoord.moveY);
      } else {
        if (
          this.xScrollCoord.moveX + this.xInitParameters.xdifference >
          this.xInitParameters.xmaxTranslate
        ) {
          this.xScrollCoord.moveX = this.xInitParameters.xmaxTranslate;
          orientation = false;
        } else if (
          this.xScrollCoord.moveX + this.xInitParameters.xdifference <
          this.xInitParameters.xminTranslate
        ) {
          this.xScrollCoord.moveX = this.xInitParameters.xminTranslate;
          orientation = true;
        } else {
          this.xScrollCoord.moveX += this.xInitParameters.xdifference;
        }
        xScroll.xTrans.translateX(this, this.xScrollCoord.moveX);
      }

      xScroll.xTrans.addTransition(
        this,
        parseFloat(xScroll.transitionTime) + "s"
      );
      this.xInitParameters.xisMove = false;

      if (
        this.xInitParameters.xtouchendCallBackFun &&
        "function" == typeof this.xInitParameters.xtouchendCallBackFun
      )
        this.xInitParameters.xtouchendCallBackFun.call(this, e, orientation);
    });

    dom.addEventListener("touchmove", function(e) {
      this.xInitParameters.xisMove = true;
      xScroll.xTrans.removeTransition(this);
      if (this.xInitParameters.xisVertical) {
        var clientY = e.touches[0].clientX;
        this.xInitParameters.xdifference = this.xInitParameters.xstart - clientY ;
        xScroll.xTrans.translateY( this, this.xScrollCoord.moveY + this.xInitParameters.xdifference);
      } else {
        var clientX = e.touches[0].clientX;
        this.xInitParameters.xdifference =
          clientX - this.xInitParameters.xstart;
        xScroll.xTrans.translateX(
          this,
          this.xScrollCoord.moveX + this.xInitParameters.xdifference
        );
      }
    });
  },

  xTrans: {
    translateX: function(dom, x) {
      dom.style["transform"] = "translateX(" + x + "px)";
      dom.style["webkitTransform"] = "translateX(" + x + "px)";
    },

    translateY: function(dom, y) {
      dom.style["transform"] = "translateY(" + y + "px)";
      dom.style["webkitTransform"] = "translateY(" + y + "px)";
    },

    removeTransition: function(dom) {
      dom.style.transition = "none";
      dom.style.webkitTransition = "none";
    },

    addTransition: function(dom, timer) {
      dom.style.transition = timer;
      dom.style.webkitTransition = timer;
    }
  },

  /**
   * 快速点击
   * @param dom
   * @param clallBackFun
   */
  onTip: function(dom, clallBackFun) {
    if (dom && typeof dom == "object") {
      dom.xonTipParameters = {
        isMove: false,
        timer: 0,
        clallBackFun: clallBackFun
      };
      dom.addEventListener("touchstart", function(e) {
        this.xonTipParameters.timer = Date.now();
        this.xonTipParameters.isMove = false;
      });

      dom.addEventListener("touchmove", function(e) {
        this.xonTipParameters.isMove = true;
      });

      dom.addEventListener("touchend", function(e) {
        if (
          !this.xonTipParameters.isMove &&
          Date.now() - this.xonTipParameters.timer < 80 &&
          this.xonTipParameters.clallBackFun &&
          "function" == typeof this.xonTipParameters.clallBackFun
        ) {
          this.xonTipParameters.clallBackFun.call(this, e);
        }
      });
    }
  }
};

import PavilionView from "@/libs/GT3DPavilionViewer";
// import { hotPavilionpavilionList } from "@/api/homeReq";
import { hallDetail } from "@/api/pavilionReq";
import { modelDtails } from "@/api/modelReq";
import { Loading, Icon, Button, Popup } from "vant";
import { Share } from "@/api/wechat";
import BScroll from "better-scroll";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      isShowLoad: true,
      isShowButton: false,
      isShowWalk: false,
      // isAutoTour: false,
      videoSrc: "",
      isShowVideo: false,
      isShowDetail: false,
      modelDetail: {},
      isPlayer: false
    };
  },
  components: {
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Popup.name]: Popup
  },
  mounted() {
    document.getElementById("view").addEventListener(
      "touchmove",
      function(e) {
        e.preventDefault();
      },
      false
    );
    // if(this.$route.params.isHot) {
    //     hotPavilion().then(res=>{
    //         let item = res.list.filter(ele=>{
    //             return ele.id === this.$route.params.id
    //         })
    //         document.title = item[0].name
    //         this.initPavilion(item[0].arrange, item[0].gems)
    //     })
    // }else {
    hallDetail(this.$route.params.id).then(res => {
      document.title = res.name;
      this.initPavilion(res.arrange, res.gems);
      if (this.$isWeChat) {
        Share(res.name, res.thumbnail, res.description, window.location.href);
      }
    });
    // pavilionList({page: this.$route.params.page, pageSize: this.$route.params.pageSize, total: this.$route.params.total}).then(res=>{
    //     let item = res.list.filter(ele=>{
    //         return ele.id === this.$route.query.id
    //     })
    //     document.title = item[0].name
    //     this.initPavilion(item[0].arrange, item[0].gems)
    // })
    // }
  },
  destroyed() {
    this.view.dispose();
  },

  methods: {
    initPavilion(arrange, gems) {
      this.view = new PavilionView({
        element: document.getElementById("view"),
        isForceHorizontal: true,
        baseUrl: "https://m.p.gemtec.ltd",
        onShowcaseClicked: this.onStart,
        onOpeningAnimaitionCompleted: this.showWalk
      });
      this.view.setSceneData(arrange, gems);
      this.view.set3DViewListener(this.onStart, this.onFinished);
      this.view.startLoadScene(undefined, this.onProgress);
    },

    onStart(item) {
      if (item.modelId) {
        // this.isShowLoad = true;
        this.isShowButton = true;
      } else if (item.video) {
        this.isShowVideo = true;
        this.videoSrc = item.video;
      } else {
        modelDtails(item.id).then(res => {
          this.isShowDetail = true;
          this.modelDetail = res;
          this.$nextTick(() => {
            let content = document.getElementById("content");
            let wrapper = document.getElementById("content-wrapper");
            content.innerHTML = res.content;
            
            xScroll.scroll(
              content,
              0,
              wrapper.offsetHeight  - content.offsetHeight,
              true,
              function() {}
            );
          });
        });
      }
    },

    showWalk() {
      this.isShowWalk = true;
    },

    onFinished() {
      this.isShowLoad = false;
    },

    onProgress(Progress) {
      if (Progress > 0.98) {
        this.isShowLoad = false;
      }
    },

    close() {
      this.view.hide3DView();
      this.isShowButton = false;
      this.isShowLoad = false;
    },

    handlerWalk() {
      this.isPlayer = !this.isPlayer;
      this.view.setAutoTour(!this.view.isAutoTour());
    },

    closeVideo() {
      this.isShowVideo = false;
      this.videoSrc = "";
      this.view.hide3DView();
    },

    buy() {
      if (window.__wxjs_environment === "miniprogram") {
        wx.miniProgram.redirectTo({
          url: `/pages/goods/index?goods_id=${this.modelDetail.productId}`
        });
      } else {
        window.location.href = `https://t.shop.gemtec.ltd/pages/goods/index?id=${this.modelDetail.productId}`
      }
      // if (
      //   document.location.host === "t.shop.gemtec.ltd" ||
      //   document.location.host === "shop.gemtec.ltd"
      // ) {
      //   window.location.href = `https://t.shop.gemtec.ltd/pages/goods/index?id=${
      //     this.modelDetail.productId
      //   }`;
      //   return;
      // }
      // wx.miniProgram.redirectTo({
      //   url: `/pages/goods/index?goods_id=${this.modelDetail.productId}`
      // });
    },
    closeDetail() {
      this.view.hide3DView();
      this.isShowDetail = false;
    }
  }
};
</script>

<style scoped lang="less">
@media screen and (orientation: portrait) {
  #view {
    position: absolute;
    width: 100vh;
    height: 100vw;
    top: 0;
    left: 100vw;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    transform-origin: 0% 0%;
  }
}

@media screen and (orientation: landscape) {
  #view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
}
// .video-wrapper{
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 999;
//   .video-close{
//     position: absolute;
//     top: 10px;
//     left: 10px;
//     font-size: 30px;
//     color: #fff;
//     z-index: 9999;
//   }
//   #video{
//     width: 100%;
//     height: 100%;
//   }
// }
.video-close {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 30px;
  color: #fff;
  z-index: 9999;
}
#video {
  width: 100%;
  height: 100%;
  z-index: 9998;
  background-color: rgba(0, 0, 0, 1);
}
.details-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  z-index: 999;
  width: 100%;
  height: 100%;
  .close {
    position: absolute;
    top: 20px;
    left: 20px;
    display: inline-block;
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background-color: #535353;
    border-radius: 50%;
    color: #fff;
    z-index: 99999;
  }
  .cart {
    position: absolute;
    top: 70px;
    left: 20px;
    font-size: 25px;
    display: inline-block;
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background-color: #535353;
    border-radius: 50%;
    color: #fff;
    z-index: 99999;
  }
  .left {
    width: 45%;
    height: 100%;
    .img-wrapper {
      background-color: #fff;
      width: 100%;
      height: 100%;
      img {
        width: 280px;
        height: 280px;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    // .button-wrapper {
    //   width: 100%;
    //   height: 20%;
    //   background-color: #fff;
    //   .buy {
    //     position: relative;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     width: 120px;
    //     height: 40px;
    //     line-height: 40px;
    //     background: rgba(205, 168, 101, 1);
    //     border-radius: 4px;
    //     font-weight: 300;
    //     color: rgba(247, 247, 247, 1);
    //     font-size: 14px;
    //   }
    // }
  }
  .right {
    width: 55%;
    height: 100%;
    background-image: url(../assets/iconImg/detaile-bg.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: #dcdcdc;
    padding: 8px 25px;
    .name {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    #content-wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
}
.close {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 25px;
  z-index: 99;
}
.loading {
  width: 30%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}
.loading-text {
  position: absolute;
  left: 50%;
  bottom: 28%;
  transform: translateX(-50%);
  z-index: 99;
  color: #cda865;
  // color: #EAEAEA;
  font-size: 12px;
}
.loading-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.button {
  position: absolute;
  bottom: 20px;
  left: 50%;
  font-size: 25px;
  color: #fff;
  transform: translateX(-50%);
  z-index: 99;
}
.play {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(128, 138, 135, 0.5);
  border-radius: 50%;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
}
</style>

